import {Component, Input} from '@angular/core';

@Component({
  selector: 'ds-upload',
  templateUrl: './upload.component.html',
})
export class UploadComponent {

  // localized widget text inputs
  @Input() public buttonTextLocalized: string;
  @Input() public orTextLocalized: string;
  @Input() public dragDropHereTextLocalized: string;

  @Input() public multipleFilesAllowed = true;

  @Input() public fileChangeFunction: Function;
  @Input() public addAttachmentService: any;
}
